import { Pipe, PipeTransform } from '@angular/core';
import { CodeSnippet } from './code-snippets/code-snippet.interface';

@Pipe({
    name: 'filterByCategory',
    pure: false,
    standalone: false
})
export class FilterByCategoryPipe implements PipeTransform {
    transform(items: any[], category: string): any {
        if (!items) {
            return items;
        }
        return items.filter((item) => {
            return item.category == category;
        })
    }
}